
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderPaymentDialog extends Serenity.EntityDialog<OrderPaymentRow, any> {
        protected getFormKey() { return OrderPaymentForm.formKey; }
        protected getIdProperty() { return OrderPaymentRow.idProperty; }
        protected getLocalTextPrefix() { return OrderPaymentRow.localTextPrefix; }
        protected getNameProperty() { return OrderPaymentRow.nameProperty; }
        protected getService() { return OrderPaymentService.baseUrl; }
        protected getDeletePermission() { return OrderPaymentRow.deletePermission; }
        protected getInsertPermission() { return OrderPaymentRow.insertPermission; }
        protected getUpdatePermission() { return OrderPaymentRow.updatePermission; }

        protected form = new OrderPaymentForm(this.idPrefix);

    }
}